// extracted by mini-css-extract-plugin
module.exports = {"contentGrid":"ViewCategoryPage_contentGrid__1R7L2","heading":"ViewCategoryPage_heading__3VC0l"};